<template>
  <div>
    <v-page-toolbar :title="$t('_menu.dashboard')" icon="mdi-monitor-dashboard">
    </v-page-toolbar>

    <v-card
      elevation="5"
      v-if="issuechartData.labels.length"
      style="top: 5px; margin-bottom: 30px"
    >
      <v-container fluid style="margin: 1px; width: 100%; height: 100%">
        <v-layout row wrap fluid>
          <v-row style="margin: 4px">
            <v-col cols="12" sm="4">
              <h4>
                {{ $t("_dashboard.issues") }}
              </h4>
              <Chart
                height="400"
                type="pie"
                :data="issuechartData"
                :options="lightOptions"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <h4>
                {{ $t("_dashboard.news") }}
              </h4>
              <Chart
                height="400"
                type="doughnut"
                :data="newsChartData"
                :options="lightOptions"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <h4>
                {{ $t("_dashboard.incidents") }}
              </h4>
              <Chart
                height="400"
                type="pie"
                :data="incidentsChartData"
                :options="lightOptions"
              />
            </v-col>
          </v-row>
        </v-layout>
      </v-container>
    </v-card>
    <v-card
      style="margin-bottom: 15px"
      elevation="5"
      v-for="(category, ind) in categoryTree"
      :key="category.name"
      class="mx-auto"
    >
      <v-container
        v-if="category.children.length"
        fluid
        style="margin: 1px; width: 100%"
      >
        <h3>
          {{ category.name }}
        </h3>
        <v-layout row wrap fluid>
          <v-flex lg6 sm6 xs12 v-for="(stat, i) in category.children" :key="i">
            <!-- {{ stat.id }} -->
            <DashboardCard
              ref="stat"
              :stat="stat"
              :ind="ind"
              :len="getPlaceCount(stat)"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <!-- <v-container>
      <h4>Sayılarla Samsun</h4>
      <v-layout row wrap fluid>
        <v-flex lg6 sm6 xs12 v-for="(stat, i) in statistics" :key="i">
          <DashboardCard ref="stat" :stat="stat" />
        </v-flex>
      </v-layout>
    </v-container> -->
  </div>
</template>

<script>
// @ is an alias to /src

import DashboardCard from "./DashboardCard";
import Chart from "primevue/chart";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "dashboard",
  components: {
    DashboardCard,
    Chart,
  },
  created() {
    this.getIssueChart();
    this.getNewsChart();
    this.getIncidentsChart();
    this.getPlaces();
  },
  data() {
    return {
      items: [
        {
          title: "card 1",
          content: "this is the content of card 1",
        },
        {
          title: "card 2",
          content: "this is the content of card 2",
        },
      ],
      filter: {
        name: "",
        cityCode: null,
        countyCode: null,
        //categoryIds: [],
      },
      incidentFilter: {
        name: "",
        cityCode: null,
        countyCode: null,
        fetchDate: null,
        //categoryIds: [],
      },
      page: 0,
      totalItemsPerPage: 10000,
      issuechartData: {
        labels: [],
        datasets: [
          {
            data: [], //[300, 50, 100],
            backgroundColor: [],
            hoverBackgroundColor: [],
          },
        ],
      },
      lightOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
      },
      newsChartData: {
        labels: [],
        datasets: [
          {
            data: [], //[300, 50, 100],
            backgroundColor: [],
            hoverBackgroundColor: [],
          },
        ],
      },
      incidentsChartData: {
        labels: [],
        datasets: [
          {
            data: [], //[300, 50, 100],
            backgroundColor: [],
            hoverBackgroundColor: [],
          },
        ],
      },
      placeLength: 0,
    };
  },
  computed: {
    ...mapGetters({ categoryTree: "category_tree/items" }),
    ...mapGetters({ language: "app/language" }),
    ...mapGetters({ places: "places/items" }),
    ...mapGetters({ issues: "issues/items" }),
    ...mapGetters({ news: "news/items" }),
    ...mapGetters({ incidents: "incidents/items" }),
  },
  methods: {
    ...mapActions(["issues/getItems"]),
    ...mapActions(["category_tree/getItems"]),
    ...mapActions(["places/getItems"]),
    ...mapActions(["news/getItems"]),
    ...mapActions(["incidents/getItems"]),

    getPlaceCount(stat) {
      let samePlaces = [];

      if (stat.children.length) {
        samePlaces = stat.children;
      } else {
        samePlaces = this.places.filter((item) => item.categoryId === stat.id);
      }
      // console.log(samePlaces.length);
      // console.log(samePlaces);
      // console.log(this.places);
      return samePlaces.length;
    },
    async getPlaces() {
      console.log("after confirm");
      let filterr = JSON.parse(JSON.stringify(this.filter));

      //filterr.categoryIds.push(placeId);

      const res = await this.$store.dispatch("places/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
      // console.log("plalalallalacececcecscscsccss", this.places.length);
      // console.log("plalalallalacececcecscscsccss", this.places);
      // return this.places.length;
    },
    async getNavMenu() {
      await this.$store.dispatch("category_tree/getItems");
    },
    async getIssueChart() {
      console.log("after confirm");
      let filterr = JSON.parse(JSON.stringify(this.filter));

      //filterr.categoryIds.push(this.routeId);
      await this.$store.dispatch("issues/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
      console.log("isssssuss", this.issues);
      let issueStatusNumber = this.issues.reduce((issue, x) => {
        if (issue[x.status] == null) {
          issue[x.status] = [x.status];
          return issue;
        } else {
          issue[x.status].push(x.status);
          return issue;
        }
      }, {});
      const values = Object.values(issueStatusNumber).values();
      for (const num of values) {
        this.issuechartData.datasets[0].data.push(num.length);
      }
      const keys = Object.keys(issueStatusNumber).values();
      for (const key of keys) {
        if (key == 0) {
          this.issuechartData.labels.push(this.$t("_enums.issueStatus.open"));
          this.issuechartData.datasets[0].backgroundColor.push("#66BB6A");
          this.issuechartData.datasets[0].hoverBackgroundColor.push("#81C784");
        } else if (key == 1) {
          this.issuechartData.labels.push(
            this.$t("_enums.issueStatus.pending")
          );
          this.issuechartData.datasets[0].backgroundColor.push("#FFA726");
          this.issuechartData.datasets[0].hoverBackgroundColor.push("#FFB74D");
        } else if (key == 2) {
          this.issuechartData.labels.push(this.$t("_enums.issueStatus.closed"));
          this.issuechartData.datasets[0].backgroundColor.push("#42A5F5");
          this.issuechartData.datasets[0].hoverBackgroundColor.push("#64B5F6");
        }
      }
    },
    async getNewsChart() {
      console.log("after confirm");
      let filterr = JSON.parse(JSON.stringify(this.filter));

      //filterr.categoryIds.push(this.routeId);
      await this.$store.dispatch("news/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
      console.log("newwsssssssssss", this.news);
      let newsStatusNumber = this.news.reduce((neww, x) => {
        if (neww[x.isArchived] == null) {
          neww[x.isArchived] = [x.isArchived];
          return neww;
        } else {
          neww[x.isArchived].push(x.isArchived);
          return neww;
        }
      }, {});
      console.log("nwewewsssnumm", newsStatusNumber);
      const values = Object.values(newsStatusNumber).values();
      for (const num of values) {
        this.newsChartData.datasets[0].data.push(num.length);
      }

      const keys = Object.keys(newsStatusNumber).values();
      for (const key of keys) {
        if (key == "false") {
          this.newsChartData.labels.push(this.$t("_enums.newsStatus.active"));
          this.newsChartData.datasets[0].backgroundColor.push("#2b730b");
          this.newsChartData.datasets[0].hoverBackgroundColor.push("#205609");
        } else if (key == "true") {
          this.newsChartData.labels.push(this.$t("_enums.newsStatus.archived"));
          this.newsChartData.datasets[0].backgroundColor.push("#6a329f");
          this.newsChartData.datasets[0].hoverBackgroundColor.push("#42136e");
        }
      }
    },
    async getIncidentsChart() {
      console.log("after confirm");

      let filterr = JSON.parse(JSON.stringify(this.incidentFilter));
      filterr.fetchAfter = "0001-01-01";
      console.log("ininini   filter", filterr);
      //filterr.categoryIds.push(this.routeId);
      await this.$store.dispatch("incidents/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
      let incidentsStatusNumber = this.incidents.reduce((neww, x) => {
        if (x.endTime > new Date()) {
          if (neww["after"] == null) {
            neww["after"] = ["after"];
            return neww;
          } else {
            neww["after"].push("after");
            return neww;
          }
        } else {
          if (neww["before"] == null) {
            neww["before"] = ["before"];
            return neww;
          } else {
            neww["before"].push("before");
            return neww;
          }
        }
      }, {});
      console.log("nwewewsssnumm", incidentsStatusNumber);
      const values = Object.values(incidentsStatusNumber).values();
      for (const num of values) {
        this.incidentsChartData.datasets[0].data.push(num.length);
      }

      const keys = Object.keys(incidentsStatusNumber).values();
      for (const key of keys) {
        if (key == "after") {
          this.incidentsChartData.labels.push(
            this.$t("_enums.incidentsStatus.ongoing")
          );
          this.incidentsChartData.datasets[0].backgroundColor.push("#ffd042");
          this.incidentsChartData.datasets[0].hoverBackgroundColor.push(
            "#fac21a"
          );
        } else if (key == "before") {
          this.incidentsChartData.labels.push(
            this.$t("_enums.incidentsStatus.ending")
          );
          this.incidentsChartData.datasets[0].backgroundColor.push("#990000");
          this.incidentsChartData.datasets[0].hoverBackgroundColor.push(
            "#c20101"
          );
        }
      }
    },
  },
  watch: {
    language: function () {
      console.log("lang changed");
      this.issuechartData.labels = [];
      this.issuechartData.datasets[0].data = [];
      this.issuechartData.datasets[0].backgroundColor = [];
      this.issuechartData.datasets[0].hoverBackgroundColor = [];
      this.getIssueChart();
      this.newsChartData.labels = [];
      this.newsChartData.datasets[0].data = [];
      this.newsChartData.datasets[0].backgroundColor = [];
      this.newsChartData.datasets[0].hoverBackgroundColor = [];
      this.getNewsChart();
      this.incidentsChartData.labels = [];
      this.incidentsChartData.datasets[0].data = [];
      this.incidentsChartData.datasets[0].backgroundColor = [];
      this.incidentsChartData.datasets[0].hoverBackgroundColor = [];
      this.getIncidentsChart();
    },
  },
};
</script>

<style>
</style>